import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, of } from 'rxjs';
import { EffectsBase } from '@ps/core-data-access';
import { IrGeneratorService } from '../services/ir-generator.service';
import { IrGeneratorActions } from './ir-generator.actions';

@Injectable()
export class IrGeneratorEffects extends EffectsBase {
  private readonly _actions$ = inject(Actions);
  private readonly _service = inject(IrGeneratorService);

  public readonly generateIR$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(IrGeneratorActions.generateIR),
      mergeMap(({ id, prompt }) =>
        this._service.generateResponse(prompt).pipe(
          map((response) =>
            IrGeneratorActions.generateIRSuccess({ id, response }),
          ),
          this.psCatchError(
            (error) =>
              of(
                IrGeneratorActions.generateIRFailure({
                  id,
                  error: error.message,
                }),
              ),
            {
              notify: true,
              customMessage:
                'An error occurred while processing your request. Please try again later.',
            },
          ),
        ),
      ),
    );
  });
}
